import React from 'react';
import DialogWithPhoto from '@components/Popups/DialogWithPhoto';
import { FEMALE_RANK_LINK } from '@constants/helpLink';
import { messages, popupBanner } from './constants';

const FirstTimeFemaleRankPopUp = ({
  isVisible,
  getUserCurrentRank,
  getUserCurrentRankText,
  onNegativeClicked
}) => (
  <DialogWithPhoto
    visible={isVisible}
    titleText={`${getUserCurrentRankText}メンバーになりました！`}
    titleImage={popupBanner[getUserCurrentRank]}
    messages={messages[getUserCurrentRank]}
    positiveButtonTitle={`${getUserCurrentRankText}ランクとは？`}
    onPositiveClicked={() => window.open(FEMALE_RANK_LINK, '_blank')}
    negativeButtonTitle={'閉じる'}
    onNegativeClicked={onNegativeClicked}
  />
);
export default FirstTimeFemaleRankPopUp;
